<template>
  <el-dialog
    title="绑定客户"
    :visible.sync="visible"
    width="600px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="120px"
      size="small"
      v-if="visible"
    >
      <el-form-item label="公司名称：">
        {{ model.company_name }}
        <!-- <el-input disabled :value="model.company_name"></el-input> -->
      </el-form-item>
      <el-form-item label="客户类型：" v-if="model.company_type">
        {{ companyTypes[model.company_type] }}
      </el-form-item>
      <el-form-item label="地区：" v-if="model.region">
        {{ CodeToText[model.region[0]] }} / {{ CodeToText[model.region[1]] }} /
        {{ CodeToText[model.region[2]] }}
      </el-form-item>
      <el-form-item label="绑定客户：">
        <customer-select
          @change="model.customer_id = $event"
          :val="model.customer_id"
          :area="model.region || []"
          :add="true"
        ></customer-select>
        <!-- <div class="font-12 text-danger">
          注：若不绑定将会根据申请名新建客户
        </div> -->
      </el-form-item>
      <el-form-item label="联系人姓名：" prop="name">
        <el-input v-model="model.name"></el-input>
      </el-form-item>
      <!-- <el-form-item class="mb-5" label="或" size="mini"> </el-form-item> -->
      <!-- <el-form-item label="绑定中间商">
        <DealerSelect
          @change="model.dealer_id = $event"
          :val="model.dealer_id"
          :add="true"
        ></DealerSelect>
      </el-form-item> -->
      <!-- <el-form-item label="绑定客户或中间商">
        <company-select
          @change="model.customer_id = $event"
          :val="model.customer_id"
        ></company-select>
        <div class="font-12 text-danger">
          注：若不绑定将会根据申请名新建客户或中间商
        </div>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { updateCustomerUser } from '@/service/getData'
import CustomerSelect from '@/components/select/customer_select'
import DealerSelect from '@/components/select/dealer_select'
import { CodeToText } from '@/util/area_tool'

export default {
  components: {
    CustomerSelect,
    DealerSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [
          { required: true, message: '联系人名称不能为空', trigger: 'change' },
        ],
      },
      CodeToText,
      companyTypes: {
        1: '最终用户',
        2: '授权经销商',
        3: 'OEM商',
      },
      companyTypeToCustomerType: {
        1: 6,
        2: 2,
        3: 3,
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.model.customer_id) {
            this.$alert('请绑定客户')
            return
          }
          // if (this.model.customer_id && this.model.dealer_id) {
          //   this.$alert('客户和中间商不能同时绑定')
          //   return
          // }
          let res = await updateCustomerUser({
            id: this.model.id,
            customer_id: this.model.customer_id,
            status: this.model.status,
            name: this.model.name,
          })
          if (res.code == 0) {
            this.visible = false
            this.$emit('updated', res.data)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.rank-price {
  display: flex;
}
</style>